import React from "react";

function Experience({ experience: { year, degree, content } }) {
  return (
    <div className="entry">
      <div className="title">
        <span>{year}</span>
      </div>
      <div className="body">
        <h4 className="mt-0">{degree}</h4>
        <ul>
        {content.map(c => (<li>{c}</li>))}
        </ul>
      </div>
    </div>
  );
}

export default Experience;
